// A file is the commission agreement when its document_category is CA. The API only accepts
// is_commission_agreement_category as a PATCH input; it is never returned on the attachment.
export const COMMISSION_AGREEMENT_CATEGORY = 'CA';
export const OTHER_ATTACHMENT_CATEGORY = 'OTH';

// Yes files the documents as the commission agreement, No as other supporting documents.
export const getCommissionAttachmentCategory = (hasCommissionAgreement) => {
  if (hasCommissionAgreement === true) return COMMISSION_AGREEMENT_CATEGORY;
  if (hasCommissionAgreement === false) return OTHER_ATTACHMENT_CATEGORY;
  return null;
};

// Only files sent with the voucher count, same as Getting Started: a deal-level file with the
// category but not on the voucher is not attached.
export const getCommissionAttachmentFiles = (files, hasCommissionAgreement) => {
  const category = getCommissionAttachmentCategory(hasCommissionAgreement);
  return category
    ? (files || []).filter(file => !!file && file.is_lease_document === true && file.document_category === category)
    : [];
};
